export default "__VITE_ASSET__BrJsidRZ__"